import { SYLLABUS_TABS } from '@/legacy-ported/constants'
import { CustomSyllabusTab, IPropWithClassName, Mapping } from '@/types'
import { getSyllabusUrlFromMappingBySyllabusCodename } from '@/utils/getSyllabusUrlFromMapping'
import clsx from 'clsx'
import { CommonCopyUrlWrapper } from '../copy-to-clipboard/CommonCopyUrlWrapper'

export interface SyllabusTabsTitleProps extends IPropWithClassName {
	tabId: CustomSyllabusTab
	mappings: Mapping[]
	syllabusCodename: string
}

export const SyllabusTabsTitle = ({
	tabId,
	mappings,
	syllabusCodename,
	className,
}: SyllabusTabsTitleProps) => {
	// Filter to syllabus mappings - by codename and apply kla_default for canonical URL
	const syllabusMappings = mappings.filter(
		(mapping) => mapping.params.navigationItem.type === 'syllabus',
	)

	const syllabusTab = SYLLABUS_TABS.find((tab) => tab.id === tabId)
	const _tabId =
		syllabusTab.id === 'course-overview' ? 'overview' : syllabusTab.id
	return (
		<CommonCopyUrlWrapper
			url={
				getSyllabusUrlFromMappingBySyllabusCodename(
					syllabusMappings,
					syllabusCodename,
					false,
					true,
				) + `/${_tabId}`
			}
			className={clsx('mb-8', className)}
		>
			<h2>
				{syllabusTab.id === 'course-overview'
					? 'Overview'
					: syllabusTab.name}
			</h2>
		</CommonCopyUrlWrapper>
	)
}
